/**
 * An owner whose workspace never finished sign-up goes back to the sign-up
 * site's step instead of into a half-built CRM. "Finished" is decided by the
 * server from what the user HAS (`user.onboardingStep` on login and
 * /auth/verify — server auth/onboardingStep.ts): a workspace with no plan
 * never ran onboarding, so it has no Super Admin on the owner, no default
 * roles or pipeline, and automations are refused ("No active plan").
 * Speak Eazy (2026-10-29) signed in here with only the plan step left.
 *
 * Members of a workspace are always "done". No step from the server (an
 * older API) = no redirect, the old behaviour.
 */
const SIGNUP_BASE =
  import.meta.env.VITE_LOGIN_URL?.replace(/\/$/, "") || "https://xale.in";

const STEP_PATHS: Record<string, string> = {
  password: "/create-password",
  company: "/onboarding",
  plan: "/onboarding/select-plan",
};

/** The sign-up page this user still has to finish, or null. */
export function signupResumeUrl(
  user: { onboardingStep?: unknown } | null | undefined,
  token: string | null | undefined,
): string | null {
  const step = user?.onboardingStep;
  if (!token || typeof step !== "string") return null;
  const path = STEP_PATHS[step];
  if (!path) return null;
  return `${SIGNUP_BASE}${path}?token=${encodeURIComponent(token)}`;
}
